import { makeAutoObservable, runInAction } from 'mobx'

import { LoadOwnerApplicationsTask } from '../Tasks/LoadOwnerApplicationsTask'

import type { ApplicationRecord } from '../Contracts/IApplication'

/**
 * Заявки одного клієнта чи перевізника для вкладки «Заявки» його картки:
 * сторінка, число, стан завантаження. Відповідь на застарілий запит
 * (клікнули іншу сторінку) відкидається.
 */
export class ApplicationOwnerListStore {
    items: ApplicationRecord[] = []
    total = 0
    page = 1
    isLoading = false
    failed = false

    private ownerUuid: string | null = null
    private requestId = 0

    constructor(
        readonly ownerField: 'client' | 'carrier',
        readonly pageSize: number
    ) {
        makeAutoObservable<ApplicationOwnerListStore, 'ownerUuid' | 'requestId'>(
            this,
            { ownerUuid: false, requestId: false, pageSize: false, ownerField: false },
            { autoBind: true }
        )
    }

    bind(ownerUuid: string): void {
        if (ownerUuid === this.ownerUuid) return

        this.ownerUuid = ownerUuid
        this.page = 1
        void this.reload()
    }

    setPage(page: number): void {
        this.page = page
        void this.reload()
    }

    async reload(): Promise<void> {
        const ownerUuid = this.ownerUuid

        if (!ownerUuid) return

        const requestId = ++this.requestId

        this.isLoading = true
        this.failed = false

        try {
            const { items, total } = await LoadOwnerApplicationsTask({
                ownerField: this.ownerField,
                ownerUuid,
                page: this.page,
                pageSize: this.pageSize,
            })

            if (requestId !== this.requestId) return

            runInAction(() => {
                this.items = items
                this.total = total
            })
        } catch {
            if (requestId !== this.requestId) return

            runInAction(() => {
                this.items = []
                this.total = 0
                this.failed = true
            })
        } finally {
            if (requestId === this.requestId) {
                runInAction(() => {
                    this.isLoading = false
                })
            }
        }
    }
}
